// extracted by mini-css-extract-plugin
export var link = "_sq-0";